import React from 'react';
import { StyleSheet, Text, View } from './base_components';

import Link from './link';

const styles = StyleSheet.create({
  breadcumbPath: {
    flexDirection: 'row',
  },
  sep: {
    marginLeft: '0.3em',
    marginRight: '0.3em',
  },
});

type Props = {
  style?: any;
  volumeName: string;
  prefix: string;
  path: string;
};
export default class BreadcrumbPath extends React.PureComponent<Props> {
  render() {
    const { style, prefix, path, volumeName } = this.props;

    const parts = path.split('/').filter((p) => p.length > 0);
    let href = prefix;
    const crumbs = parts.map((p, i) => {
      href += '/' + p;

      let name = null;
      if (i + 1 === parts.length) {
        name = <Text style={styles.path}>{p}</Text>;
      } else {
        name = <Link style={styles.path} text={p} href={href} />;
      }
      return (
        <>
          <Text style={styles.sep}>/</Text>
          {name}
        </>
      );
    });

    return (
      <View style={[styles.breadcumbPath, style]}>
        <Link style={styles.root} text={volumeName} href={prefix} />
        {crumbs}
      </View>
    );
  }
}
